import React, { useState } from 'react';
import styles from './Tabs.module.scss';  // Make sure your styles are correct
import PropTypes from 'prop-types';
import {ReactComponent as ChevronIcon} from './Chevron.svg';

const Tabs = ({ children, defaultExpanded }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  // Separate out Tab and TabPanel children
  const tabs = React.Children.toArray(children).filter(
    (child) => child.type.displayName === 'Tab'
  );

  const tabPanels = React.Children.toArray(children).filter(
    (child) => child.type.displayName === 'TabPanel'
  );

  return (
    <>
      <div className={styles.tabs}>
        {tabs.map((tab, index) => {
          if (!defaultExpanded && !isExpanded && index !== 0) return null;
          return (
            <div
              key={index}
              className={`${styles.tab} ${activeTab === index ? styles.active : ''} ${tab.props.disabled ? styles.disabled : ''}`}
            >
              <button
                onClick={() => !tab.props.disabled && handleTabClick(index)}
                disabled={tab.props.disabled}
              >
                {tab.props.children}
              </button>
              <hr />
            </div>
          );
        })}
        {!defaultExpanded && <span
          onClick={() => setIsExpanded(!isExpanded)}
          className={`${styles.toggleButton} ${isExpanded ? styles.rotate180 : ''}`}
        >
          <ChevronIcon />
        </span>}
      </div>

      <div className={styles.tabContent}>
        {tabPanels[activeTab] && tabPanels[activeTab].props.children}
      </div>
    </>
  );
};

Tabs.propTypes = {
  children: PropTypes.node.isRequired,
  defaultExpanded: PropTypes.bool,
};

const Tab = ({ children }) => {
  return <>{children}</>;
};

Tab.propTypes = {
  children: PropTypes.node.isRequired,
};

Tab.displayName = "Tab";

const TabPanel = ({ children }) => {
  return <>{children}</>;
};

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
};

TabPanel.displayName = "TabPanel";

export { Tabs, Tab, TabPanel };